/*=========================================================================================
  File Name: moduleWarehouseState.js
  Description: Warehouse Module State
  ----------------------------------------------------------------------------------------
  Item Name: POS SYSTEM
  Author: SpeedCodeLabs
  Author URL: http://www.speedcodelabs.com
==========================================================================================*/

export default {
};
